import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Input, InputNumber, Button, Icon, Alert, Row, Col, message, Select } from 'antd';
import Ink from 'react-ink';
import { yearFrom, yearTo } from './../../../config';

import {
  groupInsert,
  groupUpdate,
} from '../../../modules/group';
import {
  schoolquotaList
} from '../../../modules/schoolquota';
import {
  studentCreateMany,
  studentEdit,
} from '../../../modules/student';

const FormItem = Form.Item;
const { Option } = Select;

class GroupDetails extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
			message: null,
      schoolQuotaList: null,
		}
    this.yearList = [];
    for (let i = yearFrom; i <= yearTo; i++) {
      this.yearList.push(`${i} - ${i+1}`);
    }
	}

  componentDidMount = () => {
    this.getSchoolQuotaList();
  }


  componentDidUpdate(prevProps) {
    const { data } = this.props;
    if (prevProps.data !== data) {
      this.getSchoolQuotaList();
      if (!data) {
        this.props.form.resetFields();
      } else {
        this.props.form.setFieldsValue({
          password: data.password,
          schoolQuotaId: data.schoolQuotaId,
          className: data.className,
          quota: data.studentCount,
        });    
      }
    }
  }
	
	handleSubmit = e => {
		e.preventDefault();

		const { data } = this.props;

		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({ loading: true });

				if (!this.props.data) {
					this.props.groupInsert(values).then( 
						(res) => {
              this.props.studentCreateMany({
                classQuotaId: res._id,
                classCode: res.groupId,
                quantity: values.quota,
              }).then((res1) => {
                message.success('成功新增班別/學生!');
                this.setState({ loading: false, message: null });
                this.props.form.resetFields();
                this.props.callback();
              }).catch((err) => {
                message.error(err.response && err.response.data && err.response.data.message ? err.response.data.message : '班別已新增，但學生記錄未能更新，請編輯現有班別重試。');
                this.setState({ loading: false, message: null });
                this.props.form.resetFields();
                this.props.callback();
              });
						},
						(err) => {
							this.setState({ loading: false, message: err.response && err.response.data && err.response.data.message ? err.response.data.message : '新增失敗，請重新載入後重試。' });
						}
					);
				}
        else {
          this.props.studentEdit({
            classQuotaId: data._id,
            classCode: data.groupId,
            quantity: values.quota,
            total: true,
          }).then(() => this.props.groupUpdate(values, data._id)).then(() => {
            message.success('成功編輯班別/學生!');
            this.setState({ loading: false, message: null });
            this.props.form.resetFields();
            this.props.callback();
          }).catch(error => {
            this.setState({ loading: false, message: error.response && error.response.data && error.response.data.message
              ? error.response.data.message : '更新失敗，請重新載入後重試。' });
          });
        }
			}
		});
	}

  getSchoolQuotaList = () => {
    this.props.schoolquotaList().then((res) => {
      this.setState({schoolQuotaList: res});
    })
  }

  constructSchoolOptions = () => {
    const { schoolQuotaList } = this.state;
    if (schoolQuotaList) {
      return schoolQuotaList.results.map((item, i) => <Option value={item._id}>{`(${item.year}) ${item.school.name_tc || item.school.name_en}`}</Option>);
    }
  }

  constructYearOptions = () => {
    return this.yearList.map((item, i) => <Option value={item}>{item}</Option>);
  }

  generatePassword = () => {
    this.props.form.setFieldsValue({
      password: Math.random().toString(36).slice(-8),
    });
  }

	render() {
		
		const { loading, message, schoolQuotaList} = this.state;
		const { getFieldDecorator } = this.props.form;

		const { data } = this.props;

    const selectedQuotaId = data ? data.schoolQuotaId : this.props.form.getFieldValue('schoolQuotaId');
    const selectedSchoolQuota = schoolQuotaList
      ? schoolQuotaList.results.find(a => a._id === selectedQuotaId)
      : null;
    const groups = selectedSchoolQuota && selectedSchoolQuota.groups;
    let generatedCount = 0;
    if (groups) {
      if (Array.isArray(groups.students)) {
        generatedCount = groups.students.length;
      } else if (Array.isArray(groups)) {
        generatedCount = groups.reduce((sum, group) => sum + (group.studentCount || 0), 0);
      } else {
        generatedCount = groups.studentCount || 0;
      }
    }
    const quotaLeft = selectedSchoolQuota ? Math.max(0, selectedSchoolQuota.quota - generatedCount) : 0;
    // A restored class can reuse students even when the school quota is full.
    // The API validates the available quota when creating or restoring records.
    const maxStudents = data && selectedSchoolQuota ? Math.min(5000, data.studentCount + quotaLeft) : 5000;
		
		return (
			<Form onSubmit={this.handleSubmit} className="ownForm">
				{ (message) ? <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}

        <FormItem
					label="(年度)學校"
				>
					{ getFieldDecorator('schoolQuotaId', {
						rules: [ { required: true, message: '請選擇(年度)學校！' } ],
						initialValue: (data && data.schoolQuotaId) ? data.schoolQuotaId : "",
					})(
					  <Select disabled={data && data.schoolQuotaId}>
            {
              this.constructSchoolOptions()
            }
            </Select>
					)}
				</FormItem>

				<FormItem label="班別">
          {getFieldDecorator('className', {
            rules: [
              { required: true, message: '請輸入班別!' },
              {
                validator: (rule, value, callback) => {
                  if (value && value.length !== 2) {
                    callback('班別必須為2個字符!');
                  } else {
                    callback();
                  }
                },
              },
            ],
            initialValue: data && data.className ? data.className : "",
          })(
            <Input disabled={data && data.className} maxLength={2} />
          )}
        </FormItem>

        <Row gutter={16}>
					<Col span={12}>
            <FormItem
              label="密碼"
            >
              { getFieldDecorator('password', {
                rules: [ { required: true, message: '請輸入密碼！' } ],
                initialValue: (data && data.password) ? data.password : "",
              })(
                <Input/>
              )}
            </FormItem>
					</Col>
          <Col span={12}>
            <Button type="primary" style={{marginTop: '25px'}} onClick={() => this.generatePassword()}>自動生成</Button>
          </Col>
				</Row>

        <FormItem
					label={data && schoolQuotaList ? `學生數量 (剩餘限額: ${quotaLeft})` : "學生數量"}
				>
					{ getFieldDecorator('quota', {
						rules: [ { required: true, type: 'number', min: 1, max: maxStudents, message: `學生數量必須介乎 1 至 ${maxStudents}！` } ],
						initialValue: data ? data.studentCount : undefined,
					})(
					<InputNumber min={1} max={maxStudents} precision={0} style={{ width: '100%' }} />
					)}
				</FormItem>

				<FormItem 
					className="noMarginBtm"
				>
					<Button type="primary" htmlType="submit" disabled={loading} style={{ width: '100%' }}><Ink /><Icon type="arrow-right" /> 提交</Button>
				</FormItem>
			</Form>
		);
	}
}

const WrappedGroupDetailsModal  = Form.create()(GroupDetails);

const mapStateToProps = state => ({
  schoolQuotaListData: state.schoolquota.data,
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		groupInsert,
		groupUpdate,
    schoolquotaList,
    studentCreateMany,
    studentEdit,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedGroupDetailsModal);
